//DBTables

import { BFLType } from "../../types/DBTables";
import { post } from "../../modules/server";
import Notify from "devextreme/ui/notify";
import { IModuleRound, IRoundHeaderViewModel, RoundStatus, useRound } from "../../modules/roundHandler";
import ModuleRoundForm from "./ModuleRoundForm";
import ModuleBFLForm from "./BFL/ModuleBFLForm";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./ModuleFamilyRoundStep.module.css";
import { logAndNotifyError, logDebugSilently, notifyError, notifySuccess, notifyWarning } from "../../modules/logger";
import { useGlobalData } from "../GlobalDataProvider";
import { Breadcrumb, BreadcrumbItem, Card, ListGroup, ListGroupItem } from "react-bootstrap";
import { Colors } from "../../modules/Colors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faCircleInfo, faCircleQuestion, faPlugCircleMinus, faCircleMinus } from "@fortawesome/free-solid-svg-icons";
import { IKontrollResultRowDriftoptimering } from "../../types/BFL/Funktionskontroll";
import { useRef, useState } from "react";
import { useScrollOnPathChange } from "../../hooks/useScrollOnPathChange";

interface IProps {
  header: IRoundHeaderViewModel;
  onPrevious: () => void;
  onNext: (data: any) => void;
}

const ModuleFamilyRoundStep = ({ header, onPrevious, onNext }: IProps) => {
  const navigate = useNavigate();
  const globalData = useGlobalData();
  const [showSaveAsPanel, setShowSaveAsPanel] = useState(false);
  const [saveAsName, setSaveAsName] = useState<string | undefined>("");
  const pageTopRef = useRef<HTMLDivElement>(null);
  useScrollOnPathChange(pageTopRef, { offset: 130, smooth: true, delayMs: 0 });

  logDebugSilently("Render ModuleFamilyRoundStep:" + new Date());

  const { roundId, stepIndex, moduleIndex, BLFIndex } = useParams();
  const roundHandler = useRound();

  let selectedModule: IModuleRound | undefined = undefined;

  let bfName: BFLType = BFLType.Unknown;

  if (moduleIndex) {
    const modIndex = Number(moduleIndex);
    selectedModule = header.modules[modIndex];
  }

  const allModulesReady = header?.allModulesReady ? header.allModulesReady : () => false;

  const onSelectModule = (module: IModuleRound, index: number) => {
    navigate("/round/" + roundId + "/" + stepIndex + "/" + index);
  };

  const onModuleCancel = () => {
    navigate("/round/" + roundId + "/" + stepIndex);
  };

  const onBFCancel = () => {
    navigate(-1);
  };

  const onSaveAs = () => {
    setShowSaveAsPanel(true);
  };

  const onSaveAsName = async () => {
    const name = saveAsName;
    if (!name) {
      notifyError("Namn saknas!");
      return;
    }

    const theRound = roundHandler.getFinishedRound();

    if (theRound) {
      theRound.name = name;
      theRound.id = 0;
      // if (theRound.status === RoundStatus.Draft) {
      if (true) {
        try {
          const res = await post("SaveRound", theRound);
          if (res.round) notifySuccess("En kopia av ronderingen har sparats som " + name);
        } catch (ex) {
          notifyError("Ändringarna kunde inte sparas - Vänligen prova igen senare!");
        }
      }
    }
    setShowSaveAsPanel(false);
  };

  const onSaveDraft = async (data: any, hasChanges: boolean) => {
    if (selectedModule) {
      selectedModule.data = data;

      const bfs = roundHandler.getBFNames(selectedModule.moduleTypeId);

      //Mark this and all subsequent modules as NOT ready
      const roundVM = roundHandler.getActiveRound();
      if (!roundVM) {
        notifyError("Ändringarna kunde inte sparas - Vänligen prova igen senare!");
        return;
      }
      if (hasChanges) {
        const iStepIndex = Number(stepIndex);
        for (let i = iStepIndex; i < roundVM?.steps.length; i++) {
          const step = roundVM.steps[i];
          if (step.data?.modules) {
            const jStart = i === iStepIndex ? Number(moduleIndex) : 0;
            for (let j = jStart; j < step.data.modules.length; j++) {
              step.data.modules[j].ready = false;
            }
          }
        }
      }
      //if (!bfs.length) {
      selectedModule.ready = false;
      //}
      //Save a draft
      const theRound = roundHandler.getFinishedRound();
      if (theRound) {
        if (theRound.status === RoundStatus.Draft) {
          try {
            const res = await post("SaveRound", theRound);
            if (res?.succeeded) {
              roundHandler.updateLastRoundLocally(res.round);
              Notify("Ändringarna har sparats(draft)", "success");
            } else {
              //Notify("Ändringarna har inte kunnat sparas", "warning");
            }
          } catch (ex) {
            notifyWarning("Ändringarna kunde inte sparas - Vänligen prova igen senare!");
          }
        } //else theRound is finished => Readonly
      }

      if (bfs.length) navigate("/round/" + roundId + "/" + stepIndex + "/" + moduleIndex + "/0");
      else {
        navigate("/round/" + roundId + "/" + stepIndex);
      }

      navigate("/round/" + roundId + "/" + stepIndex);
    }
  };

  const onModuleSave = async (data: any, hasChanges: boolean) => {
    if (selectedModule) {
      selectedModule.data = data;

      const bfs = roundHandler.getBFNames(selectedModule.moduleTypeId);
      //Mark this and all subsequent modules as NOT ready
      const roundVM = roundHandler.getActiveRound();
      if (!roundVM) {
        notifyError("Ändringarna kunde inte sparas - Vänligen prova igen senare!");
        return;
      }
      if (roundVM.status !== RoundStatus.Finished && hasChanges) {
        selectedModule.lastUpdated = new Date();
      }
      if (hasChanges) {
        const iStepIndex = Number(stepIndex);
        for (let i = iStepIndex; i < roundVM?.steps.length; i++) {
          const step = roundVM.steps[i];
          if (step.data?.modules) {
            const jStart = i === iStepIndex ? Number(moduleIndex) : 0;
            for (let j = jStart; j < step.data.modules.length; j++) {
              step.data.modules[j].ready = false;
            }
          }
        }
      }
      if (!bfs.length) {
        selectedModule.ready = true;
      }
      //Save a draft
      const theRound = roundHandler.getFinishedRound();

      if (theRound) {
        if (theRound.status === RoundStatus.Draft) {
          try {
            const res = await post("SaveRound", theRound);
            if (res?.succeeded) {
              roundHandler.updateLastRoundLocally(res.round);
              Notify("Ändringarna har sparats(draft)", "success");
            } else {
              //Notify("Ändringarna har inte kunnat sparas", "warning");
            }
          } catch (ex) {
            if (globalData.isOnline) {
              notifyWarning("Ändringarna kunde inte sparas - Ronderingen kan fortsättas men behöver sparas vid något senare tillfälle !", 8000);
            }
          }
        } //else theRound is finished => Readonly
      }

      if (bfs.length) navigate("/round/" + roundId + "/" + stepIndex + "/" + moduleIndex + "/0");
      else {
        navigate("/round/" + roundId + "/" + stepIndex);
      }
    }
  };

  const onBFSave = async (bfFormData: any) => {
    if (selectedModule && moduleIndex !== undefined && BLFIndex) {
      if (bfFormData?.driftOptimeringar?.length) {
        //Driftoptimering ALLTID Åtgärdad
        bfFormData.driftOptimeringar.forEach((element: IKontrollResultRowDriftoptimering) => {
          element.Åtgärdad = true;
        });
      }

      if (!selectedModule.bfs) selectedModule.bfs = {};

      selectedModule.bfs[bfFormData.bfName as BFLType] = bfFormData;

      const theRound = roundHandler.getFinishedRound();
      if (theRound) {
        if (theRound.status === RoundStatus.Draft) {
          try {
            const res = await post("SaveRound", theRound);
            if (res?.succeeded) {
              roundHandler.updateLastRoundLocally(res.round);
              Notify("Ändringarna har sparats(draft)", "success");
            } else {
              //Notify("Ändringarna har inte kunnat sparas", "warning");
            }
          } catch (ex) {
            if (globalData.isOnline) {
              notifyWarning("Ändringarna kunde inte sparas - Ronderingen kan fortsättas men behöver sparas vid något senare tillfälle !", 8000);
            }
          }
        } //else theRound is finished => Readonly
      }

      const nextBFLIndex = Number(BLFIndex) + 1;

      const bfs = roundHandler.getBFNames(selectedModule.moduleTypeId);
      if (nextBFLIndex < bfs.length) {
        navigate("/round/" + roundId + "/" + stepIndex + "/" + moduleIndex + "/" + nextBFLIndex.toString());
      } else {
        selectedModule.ready = true;
        navigate("/round/" + roundId + "/" + stepIndex);
      }
    }
  };

  const onGoNext = () => {
    if (!allModulesReady()) {
      //Notify("Du måste först rondera alla moduler under " + header.title, "warning");
      let i = 0;
      while (i < header.modules.length && header.modules[i].ready) i++;
      if (i < header.modules.length) onSelectModule(header.modules[i], i);
    } else onNext("");
  };

  if (!selectedModule) {
    return (
      <div ref={pageTopRef}>
        <ListGroup className="list-group-flush">
          {header.modules.map((m, i) => (
            <ListGroupItem role="button" key={m.id} onClick={() => onSelectModule(m, i)}>
              {m.ready ? (
                <FontAwesomeIcon icon={faCircleCheck} className="me-3" color={Colors.GreenDark} />
              ) : (
                <FontAwesomeIcon icon={faCircleMinus} className="me-3" color={Colors.YellowMedium} />
              )}
              {m.name}
            </ListGroupItem>
          ))}
        </ListGroup>
        {/* <ul className="list-group">
          {header.modules.map((m, i) => (
            <li key={m.id} className={"list-group-item " + styles.ModuleListItem} onClick={() => onSelectModule(m, i)} style={{ background: Colors.GrayLightest }}>
              {m.ready ? <FontAwesomeIcon icon={faCircleCheck} className="me-3" color={Colors.GreenDark} /> : <> </>}
              {m.name}
            </li>
          ))}
        </ul> */}
        <Card.Body className="p-0"></Card.Body>
        <Card.Footer>
          {globalData.user?.roles.Admin &&
            (showSaveAsPanel ? (
              <div className="module">
                <form>
                  <div className="row">
                    <div className="col">
                      <input
                        type="text"
                        className="form-control ms-2"
                        style={{ width: "auto" }}
                        placeholder="Namn på ronderingen"
                        value={saveAsName}
                        onChange={(e) => setSaveAsName((e.target as any).value)}
                      />
                    </div>
                    <div className="col">
                      <button type="button" className="btn btn-outline-primary ms-2" onClick={() => setShowSaveAsPanel(false)}>
                        Avbryt
                      </button>
                      <button type="button" className="btn btn-outline-primary ms-2" onClick={onSaveAsName}>
                        Spara
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            ) : (
              <div className="module">
                <button type="button" className="btn btn-outline-primary ms-2" onClick={onSaveAs}>
                  Spara rondering som...
                </button>
              </div>
            ))}

          <div className="footerGroup">
            <button type="button" className="btn btn-secondary ms-2" onClick={onPrevious}>
              Föregående
            </button>
            <button type="button" className={"btn ms-2" + (globalData.isOnline ? " btn-success" : " btn-warning")} onClick={onGoNext}>
              Nästa
            </button>
          </div>
        </Card.Footer>
        {/* <div className="d-grid gap-2 d-md-flex justify-content-md-end">
          <div className="flex-grow-1"></div>
          <div style={{}}></div>
        </div> */}
      </div>
    );
  } else {
    if (BLFIndex) {
      const bflIndex = Number(BLFIndex);
      const bfs = roundHandler.getBFNames(selectedModule.moduleTypeId);

      bfName = bfs[bflIndex];
    }

    if (bfName && bfName !== BFLType.Unknown) {
      return (
        <div className="bfl" ref={pageTopRef}>
          <ModuleBFLForm module={selectedModule} title={header.title} bfName={bfName} onCancel={onBFCancel} onSubmit={onBFSave}></ModuleBFLForm>
        </div>
      );
    } else {
      return (
        <div className="rondering" ref={pageTopRef}>
          {/* {getBreadcrumb()} */}
          <ModuleRoundForm module={selectedModule} onCancel={onModuleCancel} onSubmit={onModuleSave} onSaveDraft={onSaveDraft}></ModuleRoundForm>
        </div>
      );
    }
  }
};

export default ModuleFamilyRoundStep;
